import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ExistingRegularPaymentsDispatcher } from "./Variable";

export interface ExistingRegularPaymentsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ExistingRegularPaymentsStatic extends BaseStore<ExistingRegularPaymentsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ExistingRegularPaymentsDispatcher, (actionData) => this.onExistingRegularPaymentsStoreResponse(actionData));
    }

    public getLastResult(): ExistingRegularPaymentsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ExistingRegularPaymentsStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onExistingRegularPaymentsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.actionType, data: actionData.payload });
                break;
                case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
